module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0077.png.ded78286.jpg";